module.exports = __webpack_public_path__ + "img/TezosLogo_Horizontal_White.311bb5fc.png";